import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartOptionsPie } from 'src/app/models/igraph.model';

@Component({
  selector: 'app-structure-graph-pie-simple',
  templateUrl: './structure-graph-pie-simple.component.html',
  styleUrls: ['./structure-graph-pie-simple.component.css']
})
export class StructureGraphPieSimpleComponent implements OnChanges {
  @Input() graphOptions: Partial<ChartOptionsPie>;

  isValidGraphOptions: boolean = false;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['graphOptions']) {
      this.validateGraphOptions();
    }
  }

  private validateGraphOptions(): void {
    this.isValidGraphOptions = !!(
      this.graphOptions &&
      this.graphOptions.series &&
      Array.isArray(this.graphOptions.series) &&
      this.graphOptions.series.length > 0 &&
      this.graphOptions.chart &&
      this.graphOptions.chart.type &&
      this.graphOptions.labels &&
      Array.isArray(this.graphOptions.labels)
    );

    if (!this.isValidGraphOptions) {
      console.warn('Invalid pie graph options:', this.graphOptions);
    }
  }
}
